import { withDefaultProps } from '@chakra-ui/react';
import { Footer } from './customComponents/footer';
import { SideNav } from './customComponents/sideNav';
import { Button } from './components/button';
import { styles } from './styles';
import { colors } from './foundations/colors';
import { Header } from './customComponents/header';
import { Input } from './components/input';
import { fontFace } from './fontFace';
import { fonts } from './foundations/fonts';
import { Container } from './components/container';
import { Select } from './components/select';
import { sizes } from './foundations/sizes';

export default [
  {
    components: {
      Container,
      Button,
      Input,
      Select,

      // Custom components
      Footer,
      SideNav,
      Header,
    },
    fonts,
    colors,
    fontFace,
    sizes,
    styles,
    config: { cssVarPrefix: 'bc' },
  },
  withDefaultProps({
    defaultProps: {
      size: 'sm',
      variant: 'filled',
    },
    components: ['Input', 'NumberInput', 'PinInput', 'Select', 'Textarea'],
  }),
];
